// extracted by mini-css-extract-plugin
module.exports = {"Year":"MonthPicker_Year__2szOz","Month":"MonthPicker_Month__3MlHV","Selected":"MonthPicker_Selected__25u-4","label":"MonthPicker_label__2OgUq"};